import React, { useState } from 'react';

import RevealCard from '../RevealCard/RevealCard';
import Selected from '../Selected/Selected';

import * as styles from './App.module.scss';
import { characters } from '../../data/characters';

import {CardProps} from '../Card/Card';

const shuffle = (array: Array<any>) => {
  let _arr = array.slice();
  for (let i = _arr.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [_arr[i], _arr[j]] = [_arr[j], _arr[i]];
  }

  return _arr;
}

const createChances = (weights: Array<number>) => {
  const total = 50;
  let key = 0;
  let base = 0;
  return new Array(total).fill(0).map((v, index) => {
    let cap = (total * weights[key]) + base;

    if (cap <= index) {
      base = index;
      key++;
    }

    return key;
  });
};

const getRandomCard = (cards: Array<CardProps>, typeWeights: Array<number>, rarityWeights: Array<number>) => {
  const typeChances = createChances(typeWeights);
  const type = shuffle(typeChances)[0];

  const rarityChances = createChances(rarityWeights);
  const rarity = shuffle(rarityChances)[0];

  const card = shuffle(cards
      .filter(card => card.type === type)
      .filter(card => card.rarity === rarity))[0];

  if (rarity === 0) {
    cards.splice(cards.findIndex(c => c.number === card.number), 1);
  }

  return card;
};

const _characters = characters.slice();

const getPreviousCards = () => {
  let val = localStorage.getItem('card-nums');

  if (!val) {
    return false;
  }

  return JSON.parse(val);
};

const getCards = (force : any = false) => {
  let cardNums = getPreviousCards();

  if (!cardNums || force) {
    const cards = [
      getRandomCard(_characters, [1, 0, 0], [0.9,0.05,0.05]),
      getRandomCard(_characters, [1, 0, 0], [0.3,0.6,0.1]),
      getRandomCard(_characters, [0.8, 0.2, 0], [0.3,0.6,0.1]),
      getRandomCard(_characters, [1, 0, 0], [0.1,0.3,0.6]),
      getRandomCard(_characters, [0.9, 0.1, 0], [0.1,0.3,0.6]),
      getRandomCard(_characters, [0.8, 0.2, 0], [0.1,0.3,0.6]),
      getRandomCard(_characters, [0.5, 0.5, 0], [0.1,0.3,0.6]),
      getRandomCard(_characters, [0.1, 0.9, 0], [0.1,0.3,0.6]),
      getRandomCard(_characters, [0, 1, 0], [0.1,0.3,0.6]),
      getRandomCard(_characters, [0, 0.8, 0.2], [0,0,1]),
      getRandomCard(_characters, [0, 0, 1], [0,0,1]),
      getRandomCard(_characters, [0, 0, 1], [0,0,1]),
      getRandomCard(_characters, [0, 0, 1], [0,0,1]),
    ];

    localStorage.setItem('card-nums', JSON.stringify(cards.map(c => c.number)));

    return cards;
  } else {
    return cardNums.map((value: number) => {
      return characters.find(c => c.number === value)
    });
  }
};

const hasHash = (str:string) => {
  return (window.location.hash && window.location.hash.includes(str));
};
const cards = getCards(hasHash('reset'));

const App: React.FC = () => {
  const [selected, setSelected] = useState(-1);
  const [showCards, setShowCards] = useState(false);

  const getSelected = (selectedNumber: number) => {
    return characters.find(c => c.number === selectedNumber);
  }

  const debug = hasHash('debug');

  return (
    <div className={styles.app}>
      { selected > 0 && (
        <Selected
          card={getSelected(selected)}
          onClose={() => setSelected(-1)}/>
      ) }
      { !showCards && (
        <button className={styles.btn} onClick={() => setShowCards(true)}>Get your cards!</button>
      ) }
      <div className={`${showCards && styles.show} ${styles.pool}`}>
        { ( debug ? characters : cards ).map((card: CardProps, index: number) => (
          <RevealCard
            initialFlipped={!debug}
            key={`${card.name}-${index}`}
            number={index + 1}
            onSelect={(number: number) => setSelected(number)}
            {...card}/>
        )) }
      </div>
    </div>
  );
}

export default App;
